module.exports = __webpack_public_path__ + "img/2-5.16476801.png";